import { removeInhibitKeysListener } from "./removeInhibitKeysListener";

export function removePrintOverlay(removeInvokerFunction) {
    if (window.xs_printOverlayTimeout) {
        clearTimeout(window.xs_printOverlayTimeout);
    }
    document.body.classList.remove('bodyOverlay');
	setTimeout(() => {
		removeInhibitKeysListener();
	}, 3000);
	
	removeInvokerFunction && removeInvokerFunction();
}
